import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './InteractiveMapModal.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { convertToAnalyticObject } from '../../../utils/analytics';
import { get, getPageThemeColors, getColorByTheme, canUseDOM, getDictionaryItem } from '../../../utils';
import InteractiveGoogleMap from '../../atoms/InteractiveMap/InteractiveGoogleMap';
import InteractiveMapListing from '../../atoms/InteractiveMap/InteractiveMapListing';
import InteractiveMapLayout from '../../atoms/InteractiveMap/InteractiveMapLayout';
import { getTopPicksStorage } from '../../atoms/FavouriteBtn/top_picks_apis';
import { idConverter } from '../atoms/../FavouriteBtn/FavouriteBtn';
import Modal from '../../atoms/Modal/Modal';
import { useModal } from '../../atoms/Modal/useModal';
import { removeBodyOverflow } from '../InteractiveMap/utils/toggleLeftPanelOverflow';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
var InteractiveMapModal = function InteractiveMapModal(_ref) {
  var loading = _ref.loading,
    params = _ref.params,
    hits = _ref.hits,
    _ref$mainHitsPerPage = _ref.mainHitsPerPage,
    mainHitsPerPage = _ref$mainHitsPerPage === void 0 ? '10' : _ref$mainHitsPerPage,
    mainTitle = _ref.mainTitle,
    contentType = _ref.contentType,
    _ref$defaultMapZoom = _ref.defaultMapZoom,
    defaultMapZoom = _ref$defaultMapZoom === void 0 ? 10 : _ref$defaultMapZoom,
    _ref$centreMapLatitud = _ref.centreMapLatitude,
    centreMapLatitude = _ref$centreMapLatitud === void 0 ? 25.2048493 : _ref$centreMapLatitud,
    _ref$centreMapLongitu = _ref.centreMapLongitude,
    centreMapLongitude = _ref$centreMapLongitu === void 0 ? 55.2707828 : _ref$centreMapLongitu,
    dictionary = _ref.dictionary,
    eventsAnalytics = _ref.eventsAnalytics,
    filtersComponent = _ref.filtersComponent,
    mapModalColor = _ref.mapModalColor;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _useModal = useModal(),
    isShown = _useModal.isShown,
    toggle = _useModal.toggle;
  var _React$useState = React.useState(_toConsumableArray(hits)),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    listingHits = _React$useState2[0],
    setListingHits = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    mapApiReady = _React$useState4[0],
    setMapApiReady = _React$useState4[1];
  var _React$useState5 = React.useState({}),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    mapState = _React$useState6[0],
    setMapState = _React$useState6[1];
  var _React$useState7 = React.useState(true),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isVdsite = _React$useState8[0],
    setIsVdsite = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    mobileListingView = _React$useState10[0],
    setMobileListingView = _React$useState10[1];
  var _React$useState11 = React.useState(null),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    activeListingItemId = _React$useState12[0],
    setActiveListingItemId = _React$useState12[1];
  var _React$useState13 = React.useState(null),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    activePopupItem = _React$useState14[0],
    setActivePopupItem = _React$useState14[1];
  var _React$useState15 = React.useState([]),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    activeTopPicks = _React$useState16[0],
    setActiveTopPicks = _React$useState16[1];
  var defaultTypeValues = React.useRef([]);
  var noItemsInLisitng = getDictionaryItem(dictionary, 'noItemsInList') || '';
  var viewAsList = getDictionaryItem(dictionary, 'viewAsList') || '';
  var viewMoreAsList = getDictionaryItem(dictionary, 'viewMoreAsList') || '';
  var viewAsMap = getDictionaryItem(dictionary, 'viewOnMap') || '';
  var listingTitleSelected = getDictionaryItem(dictionary, 'findAndBook') || '';
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var variables = BackgroundColorHex ? {
    '--m113-interactive-map-background-color': BackgroundColorHex,
    '--m113-interactive-map-background-active-color': ActiveColorHex,
    '--m113-interactive-map-color': ColorHex
  } : {
    '--m113-interactive-map-background-color': selectedPrimaryColor,
    '--m113-interactive-map-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m113-interactive-map-color': getColorByTheme(selectedPrimaryColor)
  };
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  React.useEffect(function () {
    setListingHits(hits);
  }, [hits]);
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
    if (canUseDOM) {
      var topPicks = getTopPicksStorage();
      var topPicksList = topPicks.list || [];
      setActiveTopPicks(topPicksList.map(function (el) {
        return el.itemId;
      }));
    }
    return function () {
      setMapApiReady(false);
    };
  }, []);
  var updateLocation = function updateLocation() {
    var defaultLat = Number(centreMapLatitude);
    var defaultLng = Number(centreMapLongitude);
    var markers = [];
    if (hits.length) {
      markers = hits.map(function (el) {
        el.color = mapModalColor;
        return el;
      });
    }
    setMapState({
      lat: defaultLat,
      lng: defaultLng,
      markers: markers
    });
  };
  React.useEffect(function () {
    if (mapApiReady && !loading) {
      updateLocation();
    }
  }, [mapApiReady, loading, hits]);
  var _handleGetHitsFromMap = function handleGetHitsFromMap(mapItemsInViewPort) {
    var loadedItemsFromMap = mapItemsInViewPort.filter(function (el) {
      return el.data;
    }).map(function (el) {
      return el.data;
    });
    setListingHits(loadedItemsFromMap.length ? loadedItemsFromMap : hits);
  };
  var _handleGetActiveItemId = function handleGetActiveItemId(id) {
    setActiveListingItemId(id);
  };
  var apiReady = function apiReady() {
    setMapApiReady(true);
  };
  var getActivePopupOnMap = function getActivePopupOnMap(item) {
    setActivePopupItem(item);
  };
  var _toggleActiveTopPicks = function toggleActiveTopPicks(objectId) {
    var id = idConverter(objectId);
    var topPicks = getTopPicksStorage();
    var topPicksList = topPicks.list || [];
    var list = _toConsumableArray(topPicksList.map(function (el) {
      return el.itemId;
    }));
    if (list.includes(id)) {
      var index = list.indexOf(id);
      if (index > -1) {
        list.splice(index, 1);
      }
    } else {
      list.push(id);
    }
    setActiveTopPicks(list);
  };
  var leftBar = /*#__PURE__*/React.createElement(React.Fragment, null, filtersComponent, /*#__PURE__*/React.createElement(InteractiveMapListing, {
    analytics: eventsAnalytics,
    params: params,
    listingItems: listingHits,
    hits: hits,
    defaultTypeValues: defaultTypeValues.current,
    rtl: rtl,
    noItemsDictionary: noItemsInLisitng,
    viewAsListingDictionary: viewAsList,
    viewMoreAsListingDictionary: viewMoreAsList,
    viewAsMapDictionary: viewAsMap,
    listingTitleCommonDictionary: '',
    withMapModalView: true,
    listingTitleSelectedDictionary: "".concat(listingTitleSelected.replace('{restaurants}', "".concat(mainTitle))),
    chosenTypes: [{
      nestedFilters: {
        values: []
      },
      searchIndex: '',
      value: contentType,
      title: mainTitle
    }],
    mainHitsPerPage: mainHitsPerPage,
    activeListingItemId: activeListingItemId,
    loading: loading,
    getActivePopupOnMap: getActivePopupOnMap,
    activeTopPicks: activeTopPicks,
    toggleActiveTopPicks: function toggleActiveTopPicks(objectId) {
      return _toggleActiveTopPicks(objectId);
    },
    toggleMobileListingView: function toggleMobileListingView(listingView) {
      setMobileListingView(listingView);
    },
    mapModalColor: mapModalColor
  }));
  var rightBar = /*#__PURE__*/React.createElement(InteractiveGoogleMap, {
    mapState: mapState,
    callback: apiReady,
    handleGetHitsFromMap: function handleGetHitsFromMap(hits) {
      return _handleGetHitsFromMap(hits);
    },
    handleGetActiveItemId: function handleGetActiveItemId(id) {
      return _handleGetActiveItemId(id);
    },
    dictionary: dictionary,
    defaultMapZoom: defaultMapZoom,
    centreMapLatitude: centreMapLatitude,
    centreMapLongitude: centreMapLongitude,
    analytics: eventsAnalytics,
    params: params,
    rtl: rtl,
    activePopupItem: activePopupItem,
    activeTopPicks: activeTopPicks,
    toggleActiveTopPicks: function toggleActiveTopPicks(objectId) {
      return _toggleActiveTopPicks(objectId);
    }
  });
  var handleToggleModal = function handleToggleModal() {
    setMapApiReady(false);
    setActivePopupItem(null);
    setListingHits(hits);
    toggle();
    removeBodyOverflow();
  };
  var ToggleButton = function ToggleButton(props) {
    return /*#__PURE__*/React.createElement("button", _extends({
      type: "button",
      className: "interactive-map-modal__toggle ".concat(!isShown ? 'viewAsMap' : 'viewAsList'),
      onClick: function onClick() {
        // if (canUseDOM && !listingView) {
        //   window.scrollTo(0, 0);
        // }
        handleToggleModal();
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['viewMapButton'], params), "".concat(!isShown ? viewAsMap : viewAsList));
      }
    }, props), isShown ? /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "18.992",
      height: "14",
      viewBox: "0 0 18.992 14"
    }, /*#__PURE__*/React.createElement("g", {
      id: "Group_15417",
      "data-name": "Group 15417",
      transform: "translate(-122.531 -775.5)"
    }, /*#__PURE__*/React.createElement("line", {
      id: "Line_250",
      "data-name": "Line 250",
      x2: "12",
      transform: "translate(128.523 776.5)",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }), /*#__PURE__*/React.createElement("line", {
      id: "Line_251",
      "data-name": "Line 251",
      x2: "7",
      transform: "translate(128.523 782.5)",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }), /*#__PURE__*/React.createElement("line", {
      id: "Line_252",
      "data-name": "Line 252",
      x2: "10",
      transform: "translate(128.523 788.5)",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }), /*#__PURE__*/React.createElement("line", {
      id: "Line_253",
      "data-name": "Line 253",
      x1: "0.992",
      transform: "translate(123.531 776.5)",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }), /*#__PURE__*/React.createElement("line", {
      id: "Line_254",
      "data-name": "Line 254",
      x1: "0.992",
      transform: "translate(123.531 782.5)",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }), /*#__PURE__*/React.createElement("line", {
      id: "Line_255",
      "data-name": "Line 255",
      x1: "0.992",
      transform: "translate(123.531 788.5)",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }))) : /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "14.27",
      height: "20.015",
      viewBox: "0 0 14.27 20.015"
    }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
      id: "clip-path"
    }, /*#__PURE__*/React.createElement("rect", {
      id: "Rectangle_1684",
      "data-name": "Rectangle 1684",
      width: "14.27",
      height: "20.015",
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": "0.2"
    }))), /*#__PURE__*/React.createElement("g", {
      id: "Group_1265",
      "data-name": "Group 1265",
      "clip-path": "url(#clip-path)"
    }, /*#__PURE__*/React.createElement("path", {
      id: "Path_342",
      "data-name": "Path 342",
      d: "M10.42,13.826a3.437,3.437,0,1,0-3.445-3.46,3.449,3.449,0,0,0,3.445,3.46m0-5.6a2.129,2.129,0,0,1,2.159,2.145,2.167,2.167,0,1,1-4.333,0A2.137,2.137,0,0,1,10.42,8.221",
      transform: "translate(-3.278 -3.266)",
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": "0.2"
    }), /*#__PURE__*/React.createElement("path", {
      id: "Path_343",
      "data-name": "Path 343",
      d: "M12.357,2.282A7.206,7.206,0,0,0,7.142,0a7.226,7.226,0,0,0-5.23,2.289,6.88,6.88,0,0,0-1.9,5.172A8.453,8.453,0,0,0,.17,8.625L.418,9.6a22.409,22.409,0,0,0,2.719,5.518,36.834,36.834,0,0,0,3.549,4.706.63.63,0,0,0,.456.193A.644.644,0,0,0,7.6,19.82a36.918,36.918,0,0,0,3.534-4.705c1.977-3.082,3-5.586,3.124-7.654a6.891,6.891,0,0,0-1.9-5.18M7.142,1.27a5.926,5.926,0,0,1,4.286,1.882,5.629,5.629,0,0,1,1.559,4.23c-.146,2.4-1.9,5.449-2.926,7.055A36.686,36.686,0,0,1,7.142,18.4a36.117,36.117,0,0,1-2.934-3.958c-1.03-1.607-2.78-4.659-2.926-7.055A5.622,5.622,0,0,1,2.841,3.16a5.946,5.946,0,0,1,4.3-1.89",
      transform: "translate(0 0)",
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": "0.2"
    }))), !isShown ? viewAsMap : viewAsList);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter'],
    style: variables
  }, /*#__PURE__*/React.createElement(ToggleButton, null), /*#__PURE__*/React.createElement(Modal, {
    isShown: isShown,
    hide: handleToggleModal,
    fullPageCover: true,
    style: variables
  }, !mobileListingView ? /*#__PURE__*/React.createElement(ToggleButton, {
    id: "interactive-map-toggle"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(InteractiveMapLayout, {
    params: params,
    rtl: rtl,
    loading: loading,
    leftBar: leftBar,
    rightBar: rightBar,
    stylesVariables: variables,
    withMapModalView: true
  })));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    style = _ref2.style;
  return /*#__PURE__*/React.createElement("div", {
    className: " ".concat(commonStyles, "  ").concat(rtl ? rtlStyles : ltrStyles),
    style: style
  }, children);
};
var commonStyles = "c19y9wdy";
var ltrStyles = "l17k8pbc";
var rtlStyles = "r1nntajn";
export default InteractiveMapModal;